
import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

export const useTourRestart = () => {
  const [isRestarting, setIsRestarting] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const restartDashboardTour = async () => {
    if (!user) {
      toast.error('Please log in to start the tour');
      return;
    }

    setIsRestarting(true);
    
    try {
      console.log('🔄 [useTourRestart] Starting tour restart for user:', user.id);
      
      // Clear both localStorage and database completion flags
      localStorage.removeItem(`dashboard_tour_completed_${user.id}`);
      
      // Clear database completion flag
      const { error: dbError } = await supabase
        .from('profiles')
        .update({ dashboard_tour_completed: false })
        .eq('user_id', user.id);
      
      if (dbError) {
        console.error('❌ [useTourRestart] Error clearing database tour flag:', dbError);
        // Continue anyway, localStorage flag might be sufficient
      } else {
        console.log('✅ [useTourRestart] Database tour completion flag cleared');
      }
      
      // Set manual restart flag
      localStorage.setItem(`dashboard_tour_manual_restart_${user.id}`, 'true');
      
      // Show success message
      toast.success('Dashboard tour activated! Redirecting to dashboard...');
      
      // Navigate to dashboard with tour parameter after a brief delay
      setTimeout(() => {
        navigate('/dashboard?startTour=true');
        setIsRestarting(false);
      }, 1500);
      
    } catch (error) {
      console.error('❌ [useTourRestart] Error restarting tour:', error);
      toast.error('Failed to start tour. Please try again.');
      setIsRestarting(false);
    }
  };

  return {
    restartDashboardTour,
    isRestarting
  };
};
